import { schemes, zSchema } from "../../schema-validation";
import { WalletTransactionStatus } from "../WalletTransactionStatus";
import { WalletTransactionType } from "../WalletTransactionType";

export const odoWalletTransactionSchema = zSchema.object({
  amount: zSchema.number(),
  bank_account_id: schemes.mongoOrUuid().optional(),
  bank_account: zSchema
    .object({
      type: zSchema.string(),
      number: zSchema.string(),
    })
    .optional(),
  card_id: schemes.uuid().optional(),
  charge_id: schemes.uuid().optional(),
  date: zSchema.string(),
  description: zSchema.string(),
  last_four: zSchema.string(),
  status: zSchema.nativeEnum(WalletTransactionStatus).optional(),
  type: zSchema.nativeEnum(WalletTransactionType),
  wallet_id: schemes.uuid(),
  wallet_transaction_id: schemes.uuid(),
  charge: zSchema.number().nullish(),
  fee: zSchema.number().nullish(),
});

export type TOdoWalletTransactionSchema = zSchema.infer<
  typeof odoWalletTransactionSchema
>;
